
import React from 'react'
import { BaseNode } from '../base'
import { NODE_DEFAULTS } from '@genieartinc/schemas'
import type { NodeProps } from '../types'

/** Purpose-to-config key mapping for AI video node variants */
const PURPOSE_CONFIG_KEY: Record<string, string> = {
  create: 'video-create',
  edit: 'video-edit',
  enhance: 'video-enhance',
  tools: 'video-tools',
}

/** Purpose-specific input requirements */
const PURPOSE_REQUIREMENTS: Record<string, { promptRequired: boolean; imageRequired: boolean }> = {
  create: { promptRequired: true, imageRequired: false },
  edit: { promptRequired: true, imageRequired: true },
  enhance: { promptRequired: false, imageRequired: true },
  tools: { promptRequired: false, imageRequired: true },
}

export function VideoNode({ purpose, ...props }: Omit<NodeProps, 'config'> & { purpose?: string }) {
  const configKey = (purpose && PURPOSE_CONFIG_KEY[purpose]) || 'video'
  const config = NODE_DEFAULTS[configKey] || NODE_DEFAULTS.video
  const requirements = (purpose && PURPOSE_REQUIREMENTS[purpose]) || PURPOSE_REQUIREMENTS.create
  return <BaseNode {...props} config={config} {...requirements} />
}
